module.exports = __webpack_public_path__ + "static/media/1.46552b98.png";